import { createAction } from '../../../utils/redux/createAction';
import { CHANGE_PASSWORD_TYPES } from './constants';

export const changePasswordActions = {
  proceed: createAction(CHANGE_PASSWORD_TYPES.PROCEED),
  confirm: createAction(CHANGE_PASSWORD_TYPES.CONFIRM),
};



// WEBPACK FOOTER //
// ./src/redux/auth/changePassword/actions.js